import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '../shared/layout/layout.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';

import { NgxPermissionsModule } from 'ngx-permissions';
import { integrationRoutes } from './integrations.routes';
import { IntegrationsComponent } from './integrations.component';
import { ConfirmIntegrationComponent } from 'app/integrations/confirm-integration/confirm-integration.component';
import { IntegrationsService } from 'app/integrations/integration.service';
import { IntegrationListComponent } from './integration-list/integration-list.component';
import { SingleIntegrationComponent } from 'app/integrations/single-integration/single-integration.component';
import { IntegrationListItemComponent } from './integration-list/integration-list-item/integration-list-item.component';
import { IntegrationErrorComponent } from './integration-error/integration-error.component';
import { InitIntegrationComponent } from './init-integration/init-integration.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { IntegrationImportsComponent } from './imports/list/integration-imports.component';
import { NgxDatatableModule } from '@acaisoft/ngx-datatable';
import { IntegrationsImportService } from './imports/integration.import.service';
import { IntegrationTypeFilterComponent } from './imports/type-filter/integration-type-filter.component';
import { IntegrationImportErrorsComponent } from './imports/errors/integration-import-errors.component';
import { SingleIntegrationResolver } from './SingleIntegrationResolver';
import { LegacySingleIntegrationComponent } from './legacy-single-integration/legacy-single-integration.component';
import { IntegrationImportsTableComponent } from './imports/list/integration-imports-table/integration-imports-table.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { integrationImportReducers } from './imports/integration-imports.reducer';
import { IntegrationImportsEffects } from './imports/integration-imports.effects';
import { SearchFilterComponent } from './imports/list/search-filter/search-filter.component';
import { IntegrationImportsResolve } from './imports/integration-imports.resolve';
import { IntegrationImportErrorsResolve } from './imports/integration-import-errors.resolve';
import { DynamicZapsInitiationComponent } from './dynamic-zaps-initiation/dynamic-zaps-initiation.component';

@NgModule({
  imports: [
    CommonModule,
    LayoutModule,
    SharedModule,
    RouterModule.forChild(integrationRoutes),
    TranslateModule,
    NgxPermissionsModule,
    UiSwitchModule,
    NgxDatatableModule,
    StoreModule.forFeature('integrationImports', integrationImportReducers),
    EffectsModule.forFeature([IntegrationImportsEffects])
  ],
  declarations: [
    IntegrationsComponent,
    InitIntegrationComponent,
    ConfirmIntegrationComponent,
    IntegrationListComponent,
    SingleIntegrationComponent,
    IntegrationListItemComponent,
    IntegrationErrorComponent,
    LegacySingleIntegrationComponent,
    IntegrationImportsComponent,
    IntegrationImportErrorsComponent,
    IntegrationImportsTableComponent,
    IntegrationTypeFilterComponent,
    SearchFilterComponent,
    DynamicZapsInitiationComponent
  ],
  exports: [IntegrationsComponent],
  entryComponents: [IntegrationsComponent],
  providers: [
    IntegrationsService,
    IntegrationsImportService,
    SingleIntegrationResolver,
    IntegrationImportsResolve,
    IntegrationImportErrorsResolve
  ]
})
export class IntegrationsModule {}
